import React, { useEffect, useState, useRef } from "react";
import ErrorIcon from "../../Icons/NotificationMessage/Info";
import SuccessIcon from "../../Icons/NotificationMessage/Success";
import LoadingIcon from "../Settings/Storage/StorageCalibration/AutoCalibration/RollerLoadingAnimation";
import "./SelectField.css";
import { EInputState } from "./InputField";

type Props<T> = {
  name: string;
  value: string;
  data: Array<T>;
  onChange?: (value: string) => void;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  readOnly?: boolean;
  errorMessage?: string;
  inputState?: EInputState;
};

export default function SelectField<T>({
  name,
  value,
  data,
  onChange = () => {},
  onClick = () => {},
  className = "",
  disabled = false,
  readOnly = false,
  inputState = EInputState.Undefined,
  errorMessage,
}: Props<T>) {
  return (
    <div className="select-field-container">
      <span className="select-field-label">{name}</span>
      <div className="select-field-text">
        <select
          name={name}
          value={value}
          onChange={readOnly ? () => {} : (e) => onChange(e.target.value)}
          onClick={onClick}
          className={className}
          disabled={disabled || readOnly}
          style={{
            opacity: 1,
            border: "solid",
            minWidth: "40px",
            width: "100%",
            paddingLeft: "5px",
            boxSizing: "border-box",
            background: disabled ? "rgb(224, 224, 224)" : "transparent",
            borderColor:
              inputState == EInputState.Error ? "#C92932" : "#B4B4B4",
          }}
        >
          {data.map((option: T, index) => (
            <option key={index}>{option}</option>
          ))}
        </select>
      </div>

      {inputState == EInputState.Error && errorMessage != "" && (
        <div className="select-field-error-message">
          <ErrorIcon fill="#C92932" width="10" height="10" />
          <p>{errorMessage}</p>
        </div>
      )}

      <div className="select-field-icon">
        {inputState == EInputState.Error && (
          <div>
            <ErrorIcon fill="#C92932" width="29px" height="29px" />
          </div>
        )}
        {inputState == EInputState.Success && (
          <div>
            <SuccessIcon fill="#C92932" width="29px" height="29px" />
          </div>
        )}
        {inputState == EInputState.Loading && (
          <LoadingIcon
            style={{
              width: "29px",
              height: "29px",
              transform: "translate(-50%, -50%) scale(0.5)",
            }}
          />
        )}
      </div>
    </div>
  );
}
